import { withSiteTitle } from "@/lib/page-title";

export function adminPageTitle(title: string) {
  return withSiteTitle(`Admin · ${title}`);
}
